// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"fy","carousel__wrapper_on_sides":"gy","arrows_wrapper":"hy","arrows_wrapper_right":"iy","arrows_wrapper_vertical":"jy","arrows_wrapper_on_sides":"ky","arrow_button":"ly","carousel_arrow_left":"my","carousel_arrow_left_on_side":"ny","carousel_arrow_right_on_side":"oy","carousel_arrow":"py","arrows_wrapper_rounded":"qy","carousel__fullWidth":"ry"};
    if(module.hot) {
      // 1715091678780
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  